export default {"src":"/_next/static/media/fastForwardIcon.166ce428.svg","height":30,"width":32};